<template>
	<div class="default-wrapper">
		<loader v-if="loading" />
		<div v-else class="cards-wrapper">
			<d-card
				style="max-width:200px; margin:0 1rem 1rem 0; flex: 1 0 auto;"
				v-for="(artist, i) in filteredArtists" :key="i"
				@click='() => clickArtist(artist)'
			>
				<d-card-img v-if="artist.image_url" :src="artist.image_url" style="width:200px;height:200px;border-radius:8px 8px 0 0;"/>
				<d-card-body>
					<p>{{ artist.name }}</p>
				</d-card-body>
			</d-card>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
			}
		},
		computed: {
			filteredArtists() {
				try {
					return	this.$store.state.artists.all
                                .filter(a => a.fanzine_id === this.$store.state.fanzones.form.id)
				} catch {
					return []
				}
			},
		},
		methods: {
			clickArtist(artist) {
				const fanzoneId = this.$store.state.fanzones.form.id
				this.$router.push(`/fanzone/${fanzoneId}/artist/${artist.id}`);
			}
		},
	}
</script>

<style scoped lang="less">
	.cards-wrapper {
		display:flex;
		flex-wrap:wrap;
		cursor: pointer;
	}
</style>